module.exports = __webpack_public_path__ + "img/WechatIMG2.961a983c.png";